import { call, put, select, takeEvery } from "redux-saga/effects";

import { getCalendarEventsAPI } from "helpers";
import { getCalendarEventsSuccess, getCalendarEventsFail } from "store/actions";
import { GET_CALENDAR_EVENTS } from "./actionTypes";

export function* fetchCalendarEvents({ payload: id }) {
  try {
    const response = yield call(getCalendarEventsAPI, id);
    yield put(getCalendarEventsSuccess(response.data));
  } catch (error) {
    yield put(getCalendarEventsFail(error));
  }
}

function* eventsSaga() {
  yield takeEvery(GET_CALENDAR_EVENTS, fetchCalendarEvents);
}

export default eventsSaga;
